module.exports = __webpack_public_path__ + "static/media/github.af1cdc63.svg";